/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';

type Props = {
  content?: string | null;
};

const CareersFooter: React.FC<Props> = ({ content }) => {
  return <Markdown source={content} />;
};

export default CareersFooter;
